var _g, _path, _circle, _line, _line2, _line3, _mask, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMoMenuP02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 40,
    viewBox: "0 0 37 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1300_31857",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.9045,
    height: 36.8477,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    width: 30.9045,
    height: 36.8477,
    rx: 1,
    fill: "white",
    stroke: "#777777",
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_1300_31857)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5475 26.2032L34.3112 35.9669C34.7993 36.4551 34.7993 37.2466 34.3112 37.7347L33.9904 38.0555C33.5023 38.5436 32.7108 38.5436 32.2227 38.0555L22.459 28.2918L24.5475 26.2032Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.8682,
    cy: 19.6124,
    r: 10.6016,
    stroke: "#777777",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.9441,
    y1: 15.5234,
    x2: 19.7925,
    y2: 15.5234,
    stroke: "#245FF8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.6086,
    y1: 19.5298,
    x2: 21.128,
    y2: 19.5298,
    stroke: "#245FF8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 11.9441,
    y1: 23.5361,
    x2: 19.7925,
    y2: 23.5361,
    stroke: "#245FF8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-2_1300_31857",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.13184 0H23.7727V3.75454C23.7727 4.30683 23.325 4.75454 22.7727 4.75454H8.13184C7.57955 4.75454 7.13184 4.30683 7.13184 3.75454V0Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13184 0H23.7727V3.75454C23.7727 4.30683 23.325 4.75454 22.7727 4.75454H8.13184C7.57955 4.75454 7.13184 4.30683 7.13184 3.75454V0Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 3,
    mask: "url(#path-7-inside-2_1300_31857)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMoMenuP02);
export default __webpack_public_path__ + "static/media/ic_mo_menu_p02.59f256d5aa5a75f1ac8630dd1243283b.svg";
export { ForwardRef as ReactComponent };